/**
 * 路由配置 - 简化版（静态路由）
 */

import { getUserMenu } from '@/utils/storage';
import { convertToTwoDimensionalArray } from '@/utils/utils.array';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
export let 菜单导航路由: any[] = [];
export const RouterComponent: any = {
  // '/login': () => import('@/views/login/Login.vue'),
  '/': () => import('@/views/index/Index.vue'),
  "/ode": () => import('@/views/order/OrderList.vue'),
  "/odt": () => import('@/views/order/OrderDetail.vue'),
  "/psode": () => import('@/views/order/PsOrder.vue'),
  "/afsOde": () => import('@/views/order/AfsOrder.vue'),
  "/ode/all-ps": () => import('@/views/order/AllPsOrder.vue'),
  "/adode/screen-food": () => import('@/views/order/Kitchen.vue'),
  "/user": () => import('@/views/user/UserList.vue'),
  "/udt": () => import('@/views/user/UserDetail.vue'),
  "/fin-recs": () => import('@/views/finance/Finance.vue'),
  "/fin-uu": () => import('@/views/finance/UserEarnings.vue'),
  "/fin-uudt": () => import('@/views/finance/UserEarningsDetail.vue'),
  "/adcm/ct-all": () => import('@/views/category/CategoryAll.vue'),
  "/adcm/ls": () => import('@/views/comd/ProductList.vue'),
  "/adcm/dt": () => import('@/views/comd/ProductDetail.vue'),
  "/atxt": () => import('@/views/sys/AText.vue'),
  "/atxt/dt": () => import('@/views/sys/ATextDetail.vue'),
  "/ad/inx-id": () => import('@/views/sys/IndexZx.vue'),
  "/adcm/regcmd": () => import('@/views/comd/regComd.vue'),
  "/perms": () => import('@/views/sys/perms.vue'),
  "/role": () => import('@/views/sys/role.vue'),
  "/address": () => import('@/views/user/address.vue'),



  //商户
  "/merchant/settlement/list": () => import('@/views/merchant/list.vue'),
  "/merchant/settlement/detail": () => import('@/views/merchant/detail.vue'),


  "/zhuang_tai/lie_biao": () => import('@/views/sys/mei_ju_lie_biao.vue'),
}
const 所有路由: any[] = getUserMenu();

let 注册路由: any[] = [];

// 首先注册菜单数据中的路由
for (let inx = 0; inx < 所有路由.length; inx++) {
  const element = 所有路由[inx];
  element.value = element.path || element.label;
  if (element.path && RouterComponent[element.path]) {
    //"----------------------------------", element.path, routers.length);

    // 移除路径的前导斜杠，因为这是 children 路由
    //const childPath = element.path.startsWith('/') ? element.path.substring(1) : element.path;

    注册路由.push({
      path: element.path,
      component: RouterComponent[element.path],
      name: element.label,
      meta: { title: element.label }
    });
    //"----------------------------------", element.path, routers.length);
  }
  if (element.view !== 0) {
    菜单导航路由.push(element);
  }
}

//   // 然后注册 RouterComponent 中但不在菜单数据中的路由（如详情页）
//   const 菜单路径集合 = new Set(所有路由.map(item => item.path));
//   const 额外路由: any[] = [];

//   for (const path in RouterComponent) {
//     if (!菜单路径集合.has(path)) {
//       // 这是详情页等不需要在菜单中显示的路由
//     //   const childPath = path.startsWith('/') ? path.substring(1) : path;
//       额外路由.push({
//         path: childPath,
//         component: RouterComponent[path],
//         name: path.replace(/\//g, '-').replace(/^-/, ''), // 生成路由名称
//         meta: { title: path, hidden: true } // 标记为隐藏
//       });
//     }
//   }

// 按路径长度排序，确保短路径在前，避免前缀匹配冲突（如 /atxt 在 /atxtdt 之前）
//   额外路由.sort((a, b) => a.path.length - b.path.length);
//   注册路由.sort((a, b) => a.path.length - b.path.length);

// 将额外路由添加到注册路由中
//   注册路由.push(...额外路由);

菜单导航路由 = convertToTwoDimensionalArray(菜单导航路由);

//   const 有组件的路由 = 
console.log('菜单导航路由', 菜单导航路由);
console.log('注册路由', 注册路由);



const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('@/layouts/BasicLayout.vue'),
    children: 注册路由
    // [
    //   {
    //     path: '',
    //     name: 'Home',
    //     component: () => import('@/views/index/Index.vue'),
    //     meta: { title: '首页' }
    //   },
    //   // 订单模块
    //   {
    //     path: 'ode',
    //     name: 'OrderList',
    //     component: () => import('@/views/order/OrderList.vue'),
    //     meta: { title: '订单列表' }
    //   },
    //   {
    //     path: 'odt/:id',
    //     name: 'OrderDetail',
    //     component: () => import('@/views/order/OrderDetail.vue'),
    //     meta: { title: '订单详情' }
    //   },
    //   {
    //     path: 'ps-ode',
    //     name: 'PsOrder',
    //     component: () => import('@/views/order/PsOrder.vue'),
    //     meta: { title: '配送订单' }
    //   },
    //   {
    //     path: 'kitchen',
    //     name: 'Kitchen',
    //     component: () => import('@/views/order/Kitchen.vue'),
    //     meta: { title: '后厨屏' }
    //   },
    //   // 用户模块
    //   {
    //     path: 'user',
    //     name: 'UserList',
    //     component: () => import('@/views/user/UserList.vue'),
    //     meta: { title: '用户列表' }
    //   },
    //   {
    //     path: 'udt/:id',
    //     name: 'UserDetail',
    //     component: () => import('@/views/user/UserDetail.vue'),
    //     meta: { title: '用户详情' }
    //   }
    // ]
  }
]

export const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, _from, next) => {
  // 检查是否已登录（从 localStorage 获取用户信息）
  const userInfoStr = localStorage.getItem('accountInfo')
  const isLoggedIn = !!userInfoStr

  // 如果未登录且访问的不是登录页，则跳转到登录页
  if (!isLoggedIn && to.path !== '/login') {
    next('/login')
  } else if (isLoggedIn && to.path === '/login') {
    // 如果已登录且访问登录页，跳转到首页
    next('/')
  } else {
    next()
  }
})


